import { SWRResponse, Key } from 'swr';
import useSWRImmutable from 'swr/immutable';
import { AxiosError } from 'axios';

import { Response$getReservationFlowMerchantOptIn$Status$200 } from '../../../../openapi/generated/apiClient';
import { useClientSideApiClient } from '../../../../openapi/axiosClient';

export type UseGetReservationFlowMeValue = SWRResponse<
  Response$getReservationFlowMerchantOptIn$Status$200['application/json'],
  AxiosError
>;

export const getReservationFlowMerchantOptInKey: (
  merchant_public_id?: string,
) => Key = (merchant_public_id) => {
  if (!merchant_public_id) return null;
  return {
    path: `/api/reservation_flow/merchants/{merchant_public_id}/opt_in`,
    parameter: {
      merchant_public_id,
    },
  };
};

export const useGetReservationFlowMerchantOptIn: (
  merchant_public_id?: string,
) => UseGetReservationFlowMeValue = (merchant_public_id) => {
  const client = useClientSideApiClient();
  const key = getReservationFlowMerchantOptInKey(merchant_public_id);

  const fetcher: () => Promise<
    Response$getReservationFlowMerchantOptIn$Status$200['application/json']
  > = async () => {
    return client.getReservationFlowMerchantOptIn({
      parameter: { merchant_public_id: merchant_public_id ?? '' },
    });
  };

  // 切り替え時に不意にリダイレクトするのを防ぐためrevalidateしない
  return useSWRImmutable(key, fetcher, { shouldRetryOnError: false });
};
